export default __webpack_public_path__ + "static/media/2_center.1e7cc081.png";